enum FeatureFlagKeysEnum {
  email = 'email',
  anonymous = 'anonymous',
  tenantId = 'tenantId',
  fqTenantId = 'fqTenantId',
  portalName = 'portalName'
}

export default FeatureFlagKeysEnum;
